import $ from 'jquery'
import './utils/form-select.js'
import './utils/checkbox-dropdown.js'

import SearchGoogleMap from './searchGoogleMap.js'
import MapMarkerManager from './mapMarkerManager.js'
import SearchManager from './searchManager.js'
import DetailApiManager from './detailApiManager.js'
import CruiseCards from './objects/cruiseCards.js'
import MapMarker from './objects/mapMarker.js'
import InfoManager from './infoManager.js'
import InputManager from './inputManager.js'
import CallMeManager from './callMeManager.js'
import 'rangeslider.js/dist/rangeslider.min.js'

import 'waypoints/lib/jquery.waypoints.min.js'

window.$ = $

window.searchState = {
    'destination': "",
    'departure_date': "",
    'reservation_type': 'shared',
    'duration': 0,
    'boat_type': 0,
    'cruise_style': 0,
    'travelers_nb': 0,
    'price': '',
    'ordering': '',
};

$(document).ready(function () {
    let _search_map;

    function init_18n() {
        // Set translation
        CruiseCards.seti18nParam(I18N_TRANSLATION);
        MapMarker.seti18nParam(I18N_TRANSLATION);
        InfoManager.seti18nParam(I18N_TRANSLATION);
        InputManager.seti18nParam(I18N_TRANSLATION);
    }

    function _init_search(search_request) {
        // Get url from html
        var searchUrl = $('#search-form').data('url');
        var searchApiUrl = $('#search-form').data('api-url');
        var detailApiUrl = $('#search-form').data('detail-api-url');
        var arianeApiUrl = $('#search-form').data('ariane-api-url');
        var callMeUrl = $('#no-result-form').data('url');

        // Set API urls
        SearchManager.initUrl(searchUrl , searchApiUrl);
        DetailApiManager.setApiUrl(detailApiUrl);
        InfoManager.setApiUrl({'ariane-string':arianeApiUrl});

        // Init
        CallMeManager.init(callMeUrl);
        InputManager.initSearch(search_request);
        // First result page is rendered by python but we launch
        // the search a second time asynchronously to get all result
        // data in json/js. Serialize the whole results in python
        // is way to slow to be done during the main rendering
        // SearchManager.executeForFirstResults(search_request);

        // Update ordering label based on request
        var _orderingElement = $('.ordering-filter');
        var currentLabel = _orderingElement.find('li[data-ordering="'+ search_request.ordering + '"]').html()
        _orderingElement.find('.text-button:not(.default)').html(currentLabel);

        // Close modal if the user scroll on the search result.
        //$("#result-section").on('scroll', function(e) {
        //     $('.modal-search').modal('hide');
        //});

        //$('#searchModal').modal('show');
    }
    
    window.init_search = function(search_request) {
        // If we have search form init.
        if (!!$('#search-form').length) {
            init_18n()
            //DesktopInputManager.init();
            InputManager.init();
            // Create the search map.
            if ($(".map-section").is(':visible')) {
                // Activate Google map.
                _search_map = new SearchGoogleMap();
                _search_map.on('mapReady', function() {
                    // Associate the map.
                    //DesktopInputManager.associateMap(_search_map);
                    MapMarkerManager.setSearchMap(_search_map);
                    _init_search(search_request);
                }, this);
            } else
                _init_search(search_request);
        }
    }
});



// WEBPACK FOOTER //
// ./search/static/search/js/app.js